import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  NotificationBarEmbeddedNotification,
  NotificationBarNotification,
  NotificationBarNotificationType,
} from '../../models/notification.model';
import { NotificationBarService } from '../../services/notification-bar.service';
import * as fromNotificationBar from '../../store/reducers';

@Component({
  selector: 'mc-notification-bar',
  templateUrl: './notification-bar.component.html',
  styleUrls: ['./notification-bar.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NotificationBarComponent {
  public closeText = 'close';
  public notification$: Observable<NotificationBarNotification | null>;
  public NotificationBarNotificationType = NotificationBarNotificationType;
  public NotificationBarEmbeddedNotification = NotificationBarEmbeddedNotification;

  constructor(
    private readonly store: Store<fromNotificationBar.State>,
    private readonly notificationBarService: NotificationBarService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.notification$ = this.store.pipe(select(fromNotificationBar.getCurrentNotification)).pipe(tap(() => this.cdr.detectChanges()));
  }

  public close(): void {
    this.notificationBarService.closeCurrentNotification();
  }
}
